import { useTranslation } from 'next-i18next';
import type { Transifex } from 'types';
type AnyLanguage = Transifex.Languages;
type NonEnLanguage = Exclude<AnyLanguage, 'en'>;

// English is required because we need at least one language to be present
type EnglishRecord<T> = Record<'en', T>;
type LanguageRecord<T> = Partial<Record<NonEnLanguage, T>>;
export function useLocalisedContent<DataShape>(data: EnglishRecord<DataShape> & LanguageRecord<DataShape>) {
  const {
    i18n
  } = useTranslation('common');
  const language = i18n.language as AnyLanguage;
  return getLocalisedContent(language, data);
}
export function getLocalisedContent<DataShape>(language: AnyLanguage, data: EnglishRecord<DataShape> & LanguageRecord<DataShape>) {
  let localisedData = data.en;
  try {
    if (language in data) {
      const dataLanguage = data[language];
      if (dataLanguage) {
        localisedData = dataLanguage;
      }
    }
  } catch (err) {
    // stick with En
  }
  return localisedData;
}